import { render, staticRenderFns } from "./date-list-columns.vue?vue&type=template&id=a3c6850c"
import script from "./date-list-columns.vue?vue&type=script&lang=js"
export * from "./date-list-columns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports